import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/base.service';
import { Customer } from './customer.model';

@Injectable({
    providedIn: 'root'
})

export class CustomerService extends BaseService {

    public getCustomers(idToken: string, searchParams: any, pageSize: number, pageIndex: number) {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "last-name", searchParams.lastName);
        queryParams = this.appendQueryParam(queryParams, "first-name", searchParams.firstName);
        queryParams = this.appendQueryParam(queryParams, "business-name", searchParams.businessName);
        queryParams = this.appendQueryParam(queryParams, "email", searchParams.email);
        queryParams = this.appendQueryParam(queryParams, "dealer-id", searchParams.dealerId);
        queryParams = this.appendQueryParam(queryParams, "customer-id", searchParams.customerId);
        queryParams = this.appendQueryParam(queryParams, "per-page", pageSize);
        queryParams = this.appendQueryParam(queryParams, "page", pageIndex + 1);

        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/customers`, { headers, params: queryParams });
    }

    public getCustomer(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/customer/${id}`, { headers });
    }

    public addCustomer(idToken: string, customer: Customer) {
        const body = JSON.stringify(customer);
        const headers = this.getHeaders(idToken);
        return this.httpClient.post(`${this.backendDomain}/customer`, body, { headers });
    }

    public updateCustomer(idToken: string, customer: Customer) {
        const body = JSON.stringify(customer);
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/customer/${customer.id}`, body, { headers });
    }

    public inactivateCustomer(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/customer/inactivate/${id}`, {}, { headers });
    }

    public reactivateCustomer(idToken: string, id: number) {
        // Put must have a body. If there is no body,
        // then for an unknown reason the author
        //const body = {"id": id};
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/customer/reactivate/${id}`, {}, { headers });
    }

    public deleteCustomer(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.delete(`${this.backendDomain}/customer/${id}`, { headers });
    }

    public getCustomerNames(idToken: string, dealerId?: number, includeInactivated?: boolean) {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "dealer-id", dealerId);
        queryParams = this.appendQueryParam(queryParams, "include-inactivated", includeInactivated);
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/customer-names`, { headers, params: queryParams });
    }
}